// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"BrandCategory_cardContainer__E20ml","cardImageWrapper":"BrandCategory_cardImageWrapper__iAW5r"};